import axios from 'axios'
import { endAdminSession, getAdminToken } from '../utils/functions/auth'

const urlBase = process.env.REACT_APP_URL_BACKEND_BASE

const authHeaders = () => {
  const token = getAdminToken()
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {}
}

// Mismo criterio que product.service: un 401 en el body indica que la
// sesión no es válida o venció, así que limpiamos la sesión local.
const handleAuthResponse = response => {
  if (response?.data?.status === 401) {
    endAdminSession()
  }
  return response
}

const getAllCategories = async () => {
  let url = `${urlBase}${process.env.REACT_APP_URL_CATEGORIES}`
  url = url.replace(':accion', 'allCategories')

  const response = await axios.get(url)

  return response
}

const addCategory = async nombre => {
  let url = `${urlBase}${process.env.REACT_APP_URL_CATEGORIES}`
  url = url.replace(':accion', 'addCategory')

  const response = await axios.post(url, { nombre }, authHeaders())

  return handleAuthResponse(response)
}

const editCategory = async (id, nombre) => {
  let url = `${urlBase}${process.env.REACT_APP_URL_CATEGORIES}`
  url = url.replace(':accion', 'editCategory')

  const response = await axios.post(url, { id, nombre }, authHeaders())

  return handleAuthResponse(response)
}

const deleteCategory = async id => {
  let url = `${urlBase}${process.env.REACT_APP_URL_CATEGORIES}`
  url = url.replace(':accion', 'deleteCategory')

  const response = await axios.post(url, { id }, authHeaders())

  return handleAuthResponse(response)
}

export const categoryService = {
  getAllCategories,
  addCategory,
  editCategory,
  deleteCategory
}
